import { LayoutHOC } from 'base/ui/layout/layout';
import createStockRecevingDetail from './StockRecevingDetail';

export const createStockRecevingDetailPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createStockRecevingDetail());
};